import {useMutation, useQueryClient} from '@tanstack/react-query';
import {add} from '../services/ProductFeaturesService';
import {ProductFeature} from '../types';
import {notifySuccess, notifyError} from '../../../components/ServiceNotifications';
import {productFeaturesQueryKeys} from './useProductFeatures';

// Create only: the edit is saved by RecordsTable, the row actions by the columns hook.
export const useProductFeature = () => {
    const queryClient = useQueryClient();

    const createMutation = useMutation({
        mutationFn: (values: ProductFeature) => add(values),
        onSuccess: () => {
            notifySuccess('Product Feature created');
            queryClient.invalidateQueries({queryKey: productFeaturesQueryKeys.all});
        },
        onError: notifyError
    });

    // Resolves true when the API accepted the create; the drawer closes only then.
    const createRecord = async (values: ProductFeature): Promise<boolean> => {
        try {
            await createMutation.mutateAsync(values);
            return true;
        } catch {
            // Already surfaced by onError.
            return false;
        }
    };

    return {
        createRecord,
        createMutation,
    };
};
